// MB-I18N-2A — os EN (extrait de LanguageContext, valeurs inchangées).
export default {
  "os.nav.group.pilotage": "Workspace",
  "os.nav.group.offer": "My offer",
  "os.nav.group.sales": "My sales",
  "os.nav.group.clients": "My customers",
  "os.nav.group.purchasing": "Purchasing",
  "os.nav.item.supplier_invoices": "Supplier invoices",
  "os.nav.group.communication": "Customer communication",
  "os.nav.group.operations": "My operations",
  "os.nav.group.team": "My team",
  "os.nav.group.reports": "Reports & compliance",
  "os.nav.group.config": "Configuration",
  "os.nav.item.overview": "Overview",
  "os.nav.item.establishments": "Establishments",
  "os.nav.item.products": "Products",
  "os.nav.item.recipes": "Recipes",
  "os.nav.item.orders": "Orders",
  "os.nav.item.sales": "Sales",
  "os.nav.item.pos": "Register (POS)",
  "os.nav.item.loyalty": "Loyalty",
  "os.nav.item.rewards": "Rewards",
  "os.nav.item.reviews": "Reviews",
  "os.nav.item.wallet": "Wallet",
  "os.nav.item.news": "News",
  "os.nav.item.communication": "Customer communication",
  "os.nav.item.stock": "Stock",
  "os.nav.item.inventory": "Material inventory",
  "os.nav.item.ingredients": "Ingredients",
  "os.nav.item.material_cost": "Food cost",
  "os.nav.item.margins": "Margins",
  "os.nav.item.team": "Team",
  "os.nav.item.reports": "Reports",
  "os.nav.item.closures": "Z reports",
  "os.nav.item.compliance": "Tax compliance",
  "os.nav.item.shop": "Store",
  "os.nav.item.payments": "Payments",
  "os.nav.item.subscription": "Subscription",
  "os.nav.item.audit": "Audit Log",
  "os.nav.badge.soon": "Soon",
  "os.roadmap.eyebrow": "On the roadmap",
  "os.roadmap.back": "Back to dashboard",
  "os.roadmap.communication.title": "Customer communication",
  "os.roadmap.communication.desc": "Soon: campaigns, messages and automations to engage your customers directly from SUPERKAWA OS.",
  "os.roadmap.wallet.title": "Owner Wallet",
  "os.roadmap.wallet.desc": "Soon: manage your customers' Wallet balances, top-ups and transactions from a dedicated view.",
  "os.owner.eyebrow": "Overview",
  "os.owner.title": "All your establishments",
  "os.owner.context.consolidated": "Consolidated",
  "os.owner.context.establishment": "Establishment",
  "os.owner.context.all_establishments": "All your establishments",
  "os.owner.context.today": "Today:",
  "os.owner.context.orders_word": "orders",
  "os.owner.context.no_critical": "no critical alert",
  "os.owner.context.critical": "{n} critical alert(s)",
  "os.owner.kpi.avg_basket_hint": "today",
  "os.owner.kpi.avg_basket_hint_multi": "single currency only",
  "os.owner.kpi.customers": "Customers",
  "os.owner.kpi.customers_hint": "unique customers",
  "os.owner.section.clients": "Customers",
  "os.owner.clients.reviews": "Reviews",
  "os.owner.clients.reviews_select": "Select an establishment",
  "os.owner.clients.reviews_count": "{n} reviews",
  "os.owner.clients.reviews_empty": "No reviews yet",
  "os.owner.insights.critical": "Critical",
  "os.owner.insights.important": "Important",
  "os.owner.insights.suggestion": "Suggestion",
  "os.owner.quick.title": "Quick actions",
  "os.owner.quick.products": "Products",
  "os.owner.quick.rewards": "Rewards",
  "os.owner.quick.orders": "Orders",
  "os.owner.quick.export": "Export",
  "os.owner.subtitle": "A consolidated view of today's activity.",
  "os.owner.kpi.orders": "Orders",
  "os.owner.kpi.avg_basket": "Average basket",
  "os.owner.kpi.loyalty": "Active loyalty customers",
  "os.owner.kpi.wallets": "Active wallets",
  "os.owner.kpi.revenue": "Revenue today",
  "os.owner.kpi.revenue_hint": "today",
  "os.owner.kpi.revenue_hint_multi": "today · currencies not summed",
  "os.owner.kpi.orders_hint": "today",
  "os.owner.kpi.loyalty_hint": "all establishments",
  "os.owner.kpi.wallets_hint": "in circulation",
  "os.owner.revenue_by_currency": "Revenue by currency",
  "os.owner.multi_note": "Multiple currencies — not summed",
  "os.owner.no_orders": "No orders today yet.",
  "os.owner.orders_singular": "order",
  "os.owner.orders_plural": "orders",
  "os.owner.establishments": "Your establishments",
  "os.owner.card.revenue": "Today's revenue",
  "os.owner.card.orders": "Orders",
  "os.owner.card.avg_basket": "Avg. basket",
  "os.owner.card.customers": "Customers",
  "os.owner.card.loyalty": "Loyalty",
  "os.owner.card.wallets": "Wallets",
  "os.owner.status.active": "Active",
  "os.owner.status.inactive": "Inactive",
  "os.owner.empty.title": "No establishment yet",
  "os.owner.empty.desc": "Create your first establishment to see your consolidated figures here.",
  "os.owner.empty.cta": "Create my establishment",
  "os.owner.error.title": "Couldn't load your data",
  "os.owner.error.desc": "Something went wrong. Please try again.",
  "os.owner.error.retry": "Retry",
  "os.owner.chart.title": "Sales trend",
  "os.owner.chart.revenue": "Revenue",
  "os.owner.chart.orders": "Orders",
  "os.owner.chart.today": "Today",
  "os.owner.chart.no_sale_today": "No sales yet today",
  "os.owner.chart.empty_hint": "Sales will appear here after your first order.",
  "os.owner.chart.range7": "7 days",
  "os.owner.chart.range30": "30 days",
  "os.owner.chart.range90": "90 days",
  "os.owner.kpi.revenue_label": "Revenue",
  "os.owner.kpi.revenue_hint_multi_short": "currencies not summed",
  "os.owner.kpi.period.today": "Today",
  "os.owner.kpi.period.yesterday": "Yesterday",
  "os.owner.kpi.period.7d": "7d",
  "os.owner.kpi.period.30d": "30d",
  "os.owner.kpi.period.90d": "90d",
  "os.owner.kpi.compare.new": "New",
  "os.owner.top_products.view_products": "Products",
  "os.owner.top_products.view_categories": "Categories",
  "os.owner.categories.empty_title": "No category sold yet",
  "os.owner.categories.empty_desc": "Your best categories will appear here after the first paid sale.",
  "os.owner.categories.uncategorized": "Uncategorized",
  "os.owner.ops.title": "Operational intelligence",
  "os.owner.ops.subtitle": "Understand your activity to decide",
  "os.owner.ops.range.7d": "7d",
  "os.owner.ops.range.30d": "30d",
  "os.owner.ops.range.90d": "90d",
  "os.owner.ops.error": "Unable to load the indicators.",
  "os.owner.ops.retry": "Retry",
  "os.owner.ops.payments_title": "Payment breakdown",
  "os.owner.ops.no_transactions": "No transactions in this period.",
  "os.owner.ops.pay.card": "Card",
  "os.owner.ops.pay.cash": "Cash",
  "os.owner.ops.pay.wallet": "Wallet",
  "os.owner.ops.orders_title": "Orders trend",
  "os.owner.ops.orders.today": "Today",
  "os.owner.ops.orders.7d": "Last 7 days",
  "os.owner.ops.orders.30d": "Last 30 days",
  "os.owner.ops.customers_title": "Customers",
  "os.owner.ops.customers_new": "New",
  "os.owner.ops.customers_returning": "Returning",
  "os.owner.ops.customers_frequency": "Visits / customer",
  "os.owner.ops.coverage": "Analysis based on {identified} identified orders out of {total} ({pct}%).",
  "os.owner.ops.coverage_empty": "No identified orders in this period.",
  "os.owner.temporal.title": "Time analysis",
  "os.owner.temporal.subtitle": "Peak hours and days (90d)",
  "os.owner.temporal.not_configured_title": "Timezone not configured",
  "os.owner.temporal.not_configured_desc": "Set your establishment's timezone to unlock hourly analytics.",
  "os.owner.temporal.no_data": "Not enough paid orders yet to analyze hours and days.",
  "os.owner.temporal.error": "Unable to load the time analysis.",
  "os.owner.temporal.retry": "Retry",
  "os.owner.temporal.peak_hour": "Busiest hour",
  "os.owner.temporal.quiet_hour": "Quietest hour",
  "os.owner.temporal.best_day": "Best day",
  "os.owner.temporal.worst_day": "Weakest day",
  "os.owner.temporal.orders_count": "{count} orders",
  "os.owner.temporal.hour_range": "{from}:00 – {to}:00",
  "os.owner.temporal.coverage_partial": "{configured} establishment(s) analyzed · {unconfigured} without timezone excluded.",
  "os.owner.temporal.weekday.0": "Monday",
  "os.owner.temporal.weekday.1": "Tuesday",
  "os.owner.temporal.weekday.2": "Wednesday",
  "os.owner.temporal.weekday.3": "Thursday",
  "os.owner.temporal.weekday.4": "Friday",
  "os.owner.temporal.weekday.5": "Saturday",
  "os.owner.temporal.weekday.6": "Sunday",
  "os.owner.health.title": "Business Health",
  "os.owner.health.subtitle": "Deterministic summary · active store",
  "os.owner.health.loading": "Computing summary…",
  "os.owner.health.error": "Unable to load the summary.",
  "os.owner.health.retry": "Retry",
  "os.owner.health.score_label": "Health score",
  "os.owner.health.of_100": "/ 100",
  "os.owner.health.band.critical": "Critical",
  "os.owner.health.band.at_risk": "At risk",
  "os.owner.health.band.healthy": "Healthy",
  "os.owner.health.band.strong": "Strong",
  "os.owner.health.coverage.complete": "Full coverage",
  "os.owner.health.coverage.partial": "Partial coverage",
  "os.owner.health.active_count": "{active}/{total} dimensions assessed",
  "os.owner.health.no_shop_selected_title": "No store selected",
  "os.owner.health.no_shop_selected_desc": "Select an establishment to display its health score.",
  "os.owner.health.insufficient_title": "Not enough data for a reliable score",
  "os.owner.health.insufficient_desc": "At least {min} assessable dimensions are required, including revenue growth or customer health. Here is what is missing:",
  "os.owner.health.dim.d1": "Revenue growth",
  "os.owner.health.dim.d2": "Customer health",
  "os.owner.health.dim.d3": "Menu robustness",
  "os.owner.health.dim.d4": "Payment diversification",
  "os.owner.health.dim.d5": "Operational hygiene",
  "os.owner.health.reason.d1_insufficient": "Insufficient sales history to measure growth.",
  "os.owner.health.reason.d2_insufficient_history": "Customer history too short to assess retention.",
  "os.owner.health.reason.d2_insufficient_sample": "Too few identified customers to assess retention.",
  "os.owner.health.reason.d3_insufficient_data": "Insufficient product observation to assess the menu.",
  "os.owner.health.reason.d4_insufficient_sample": "Too few payments to assess the payment mix.",
  "os.owner.health.reason.d5_not_applicable": "Stock module not enabled for this establishment.",
  "os.owner.health.momentum.up": "Revenue up {pct}% over 30d",
  "os.owner.health.momentum.down": "Revenue down {pct}% over 30d",
  "os.owner.health.momentum.flat": "Revenue flat over 30d",
  "os.owner.health.strengths_label": "Strengths",
  "os.owner.health.risks_label": "Top risks",
  "os.owner.health.none": "No notable signal.",

  "os.owner.reco.title": "Recommendations",
  "os.owner.reco.subtitle": "What to do next — risks first",
  "os.owner.reco.loading": "Analyzing…",
  "os.owner.reco.error": "Unable to load recommendations.",
  "os.owner.reco.retry": "Retry",
  "os.owner.reco.empty_title": "Nothing to flag",
  "os.owner.reco.empty_desc": "No priority action detected right now. Everything looks under control.",
  "os.owner.reco.action_label": "Action",
  "os.owner.reco.severity.critical": "Critical",
  "os.owner.reco.severity.high": "High priority",
  "os.owner.reco.severity.medium": "Watch",
  "os.owner.reco.severity.low": "Opportunity",
  "os.owner.reco.dead_observation": "Underperforming-product analysis in progress: {pending} product(s) in observation period ({days} days minimum) before evaluation.",
  "os.owner.reco.menu.concentration.title": "Revenue concentration",
  "os.owner.reco.menu.concentration.desc": "Your top {count} products account for {pct}% of revenue in {currency}. A strong dependency on a few items.",
  "os.owner.reco.menu.concentration.action": "Secure their availability and diversify sales.",
  "os.owner.reco.menu.star.title": "Star product: {name}",
  "os.owner.reco.menu.star.desc": "{name} generates {pct}% of revenue in {currency}. It's a flagship item.",
  "os.owner.reco.menu.star.action": "Secure its stock and promote it.",
  "os.owner.reco.menu.dead.title": "Low-selling product: {name}",
  "os.owner.reco.menu.dead_zero.desc": "{name} recorded no sales over 90 days.",
  "os.owner.reco.menu.dead_low.desc": "{name} sold only {units} unit(s) over 90 days.",
  "os.owner.reco.menu.dead.action": "Consider removing or repositioning it.",
  "os.owner.reco.customers.coverage_low.title": "Too many anonymous orders",
  "os.owner.reco.customers.coverage_low.desc": "Only {pct}% of your orders are linked to an identified customer. Your customer analytics stay partial.",
  "os.owner.reco.customers.coverage_low.action": "Encourage identification via QR, Wallet or loyalty at checkout.",
  "os.owner.reco.customers.retention_low.title": "Low customer retention",
  "os.owner.reco.customers.retention_low.desc": "Only {pct}% of your identified customers come back. Retention needs strengthening.",
  "os.owner.reco.customers.retention_low.action": "Activate loyalty, win-back or targeted repeat-purchase campaigns.",
  "os.owner.reco.customers.frequency_low.title": "Low purchase frequency",
  "os.owner.reco.customers.frequency_low.desc": "Your identified customers buy {frequency} times on average. Few repeat visits.",
  "os.owner.reco.customers.frequency_low.action": "Create a return mechanic: loyalty or targeted offer.",
  "os.owner.reco.customers.loyal_base.title": "Loyal customer base",
  "os.owner.reco.customers.loyal_base.desc": "{pct}% of your identified customers return. A solid loyal base, your best asset.",
  "os.owner.reco.customers.loyal_base.action": "Protect it with targeted loyalty perks; avoid overly aggressive promotions.",
  "os.owner.reco.payments.method.card": "card",
  "os.owner.reco.payments.method.cash": "cash",
  "os.owner.reco.payments.method.wallet": "Wallet",
  "os.owner.reco.payments.dependence.title": "Reliance on a single method",
  "os.owner.reco.payments.dependence.desc": "The \"{method}\" method accounts for {pct}% of your settlements. An outage or refusal on this channel would block collection.",
  "os.owner.reco.payments.dependence.action": "Diversify accepted payment methods (card, cash, Wallet).",
  "os.owner.reco.payments.wallet_opportunity.title": "Untapped Wallet potential",
  "os.owner.reco.payments.wallet_opportunity.desc": "Across {orders} settlements, Wallet is only {pct}%. Enough volume to make it a real loyalty lever.",
  "os.owner.reco.payments.wallet_opportunity.action": "Launch a top-up campaign or a Wallet bonus at checkout.",
  "os.owner.reco.payments.wallet_low.title": "Low Wallet adoption",
  "os.owner.reco.payments.wallet_low.desc": "Wallet accounts for only {pct}% of your settlements. Its adoption remains marginal.",
  "os.owner.reco.payments.wallet_low.action": "Encourage Wallet top-ups with a bonus or loyalty perk.",
  "os.owner.reco.payments.balanced.title": "Balanced payment mix",
  "os.owner.reco.payments.balanced.desc": "Card {card}%, cash {cash}%, Wallet {wallet}%: a healthy split that limits reliance on a single channel.",
  "os.owner.reco.payments.balanced.action": "Preserve this diversity and keep your Wallet incentives.",
  "os.owner.reco.temporal.peak_hour_focus.title": "Peak hour: {hour}:00",
  "os.owner.reco.temporal.peak_hour_focus.desc": "The {hour}:00 slot takes {pct}% more orders than the average of your other active hours.",
  "os.owner.reco.temporal.peak_hour_focus.action": "Reinforce staffing, prep and product availability around {hour}:00.",
  "os.owner.reco.temporal.weekday_dropoff.title": "Slow day: {weekday}",
  "os.owner.reco.temporal.weekday_dropoff.desc": "On {weekday} you record {pct}% fewer orders than the average of your other days.",
  "os.owner.reco.temporal.weekday_dropoff.action": "Test an event, a targeted offer or a loyalty campaign on {weekday}.",
  "os.owner.reco.temporal.quiet_hour_activation.title": "Quiet hour: {hour}:00",
  "os.owner.reco.temporal.quiet_hour_activation.desc": "The {hour}:00 slot stays {pct}% below the average of your active hours.",
  "os.owner.reco.temporal.quiet_hour_activation.action": "Run an off-peak offer, a Wallet campaign or a loyalty perk around {hour}:00.",
  "os.owner.reco.temporal.best_weekday_leverage.title": "Strong day: {weekday}",
  "os.owner.reco.temporal.best_weekday_leverage.desc": "{weekday} generates {pct}% more orders than the average of your other days.",
  "os.owner.reco.temporal.best_weekday_leverage.action": "Identify what makes {weekday} strong and replicate it on your other days.",

  "os.owner.chart.empty": "No sales in this period.",
  "os.owner.chart.error": "Could not load the chart.",
  "os.owner.sales_by_store.title": "Sales by establishment",
  "os.owner.sales_by_store.empty": "No sales to break down today.",
  "os.owner.top_products.title": "Top products",
  "os.owner.top_products.tab_sales": "Sales",
  "os.owner.top_products.tab_qty": "Quantities",
  "os.owner.top_products.qty_unit": "sold",
  "os.owner.top_products.empty": "No product sales yet.",
  "os.owner.top_products.empty_title": "No sales today",
  "os.owner.top_products.empty_desc": "Your best sellers will appear here as soon as the first order is paid.",
  "os.owner.header.today": "Today",
  "os.owner.header.export": "Export",
  "os.owner.header.add_establishment": "Add establishment",
  "os.owner.header.soon": "Coming soon",
  "os.nav.item.ws_team": "Team",
  "os.team.title": "Workspace team",
  "os.team.subtitle": "Invite collaborators and manage their access to establishments.",
  "os.team.invite_cta": "Invite a member",
  "os.team.search_placeholder": "Search by name, email or location…",
  "os.team.search_no_results": "No results for this search.",
  "os.team.loading": "Loading team…",
  "os.team.error": "Unable to load the team. Please try again.",
  "os.team.retry": "Retry",
  "os.team.no_shops": "No establishment",
  "os.team.role.manager": "Manager",
  "os.team.role.member": "Member",
  "os.team.role.owner": "Owner",
  "os.team.status.pending": "Pending",
  "os.team.status.active": "Active",
  "os.team.modal.title": "Invite a member",
  "os.team.modal.description": "The collaborator will receive an email to create their account and access the selected establishments.",
  "os.team.modal.email_label": "Email",
  "os.team.modal.email_placeholder": "collaborator@email.com",
  "os.team.modal.name_label": "Name (optional)",
  "os.team.modal.name_placeholder": "Collaborator name",
  "os.team.modal.role_label": "Role",
  "os.team.modal.shops_label": "Establishments",
  "os.team.modal.shops_empty": "No establishment available.",
  "os.team.modal.submit": "Send invitation",
  "os.team.modal.sending": "Sending…",
  "os.team.modal.cancel": "Cancel",
  "os.team.modal.err_email": "Invalid email address.",
  "os.team.modal.err_shops": "Select at least one establishment.",
  "os.team.modal.success": "Invitation sent.",
  "os.team.modal.error": "Unable to send the invitation.",
  "os.team.pending.title": "Pending invitations",
  "os.team.pending.empty": "No pending invitations.",
  "os.team.pending.col_email": "Email",
  "os.team.pending.col_role": "Role",
  "os.team.pending.col_shops": "Locations",
  "os.team.pending.col_date": "Date",
  "os.team.pending.col_status": "Status",
  "os.team.pending.col_actions": "Actions",
  "os.team.pending.cancel": "Cancel",
  "os.team.pending.cancelled": "Invitation cancelled.",
  "os.team.pending.cancel_error": "Unable to cancel the invitation.",
  "os.team.members.title": "Active members",
  "os.team.members.empty": "No active members yet.",
  "os.team.members.col_name": "Name",
  "os.team.members.col_email": "Email",
  "os.team.members.col_role": "Role",
  "os.team.members.col_shops": "Locations",
  "os.team.members.col_last_login": "Last sign-in",
  "os.team.members.col_actions": "Actions",
  "os.team.members.view": "View",
  "os.team.members.never": "—",
  "os.team.member_detail.title": "Member details",
  "os.team.member_detail.close": "Close",
  "os.team.member_detail.status": "Status",
  "os.team.member_detail.joined": "Member since",
  "os.team.member_detail.primary_owner": "Primary owner",
  "os.team.member_detail.primary_owner_note": "The primary owner cannot be edited or removed.",
  "os.team.member_detail.edit_stores": "Edit access",
  "os.team.member_detail.remove": "Remove from Organization",
  "os.team.edit_stores.title": "Edit access",
  "os.team.edit_stores.description": "Select the establishments {name} can access in this workspace.",
  "os.team.edit_stores.shops_empty": "No establishment available.",
  "os.team.edit_stores.save": "Save",
  "os.team.edit_stores.saving": "Saving…",
  "os.team.edit_stores.cancel": "Cancel",
  "os.team.edit_stores.success": "Access updated.",
  "os.team.edit_stores.error": "Unable to update access.",
  "os.team.remove.title": "Remove this member?",
  "os.team.remove.description": "{name} will no longer have access to this workspace's establishments. Their access to other workspaces and their account remain intact.",
  "os.team.remove.confirm": "Remove member",
  "os.team.remove.removing": "Removing…",
  "os.team.remove.cancel": "Cancel",
  "os.team.remove.success": "Member removed from the workspace.",
  "os.team.remove.error": "Unable to remove the member.",
  "os.nav.item.ws_cockpit": "Dashboard",
  "os.nav.item.dashboard": "Dashboard",
  "os.nav.item.consolidated": "Consolidated view",
  "os.nav.item.ws_settings": "Settings",
  "os.nav.item.ws_account": "My account",
  "os.wss.title": "Workspace settings",
  "os.wss.subtitle": "Legal information and preferences shared by all your locations.",
  "os.wss.workspace_label": "Workspace",
  "os.wss.loading": "Loading settings…",
  "os.wss.error": "Unable to load settings. Please try again.",
  "os.wss.retry": "Retry",
  "os.wss.save": "Save changes",
  "os.wss.saving": "Saving…",
  "os.wss.cancel": "Cancel",
  "os.wss.save_success": "Settings saved.",
  "os.wss.save_error": "Unable to save settings.",
  "os.wss.unsaved": "Unsaved changes",
  "os.wss.general.title": "General information",
  "os.wss.general.desc": "Your workspace identity.",
  "os.wss.general.name": "Organization name",
  "os.wss.general.name_ph": "e.g. SUPERKAWA Group",
  "os.wss.general.description": "Description",
  "os.wss.general.description_ph": "Describe your business (optional)",
  "os.wss.general.logo": "Logo",
  "os.wss.general.logo_ph": "Logo URL (https://…)",
  "os.wss.general.logo_hint": "Paste an image URL. Advanced hosting is coming later.",
  "os.wss.general.country": "Primary country",
  "os.wss.general.language": "Default language",
  "os.wss.general.timezone": "Time zone",
  "os.wss.legal.title": "Legal information",
  "os.wss.legal.desc": "Used for your official documents. International-ready.",
  "os.wss.legal.legal_name": "Legal name",
  "os.wss.legal.commercial_name": "Trading name",
  "os.wss.legal.registration_number": "Registration number (SIREN/SIRET or equivalent)",
  "os.wss.legal.vat_number": "VAT number",
  "os.wss.legal.address": "Address",
  "os.wss.legal.city": "City",
  "os.wss.legal.postal_code": "Postal code",
  "os.wss.legal.country": "Organization registration country",
  "os.wss.legal.country_hint": "This setting applies to the legal entity, not to the country of your locations.",
  "os.wss.prefs.title": "Preferences",
  "os.wss.prefs.desc": "Display and localization.",
  "os.wss.prefs.date_format": "Date format",
  "os.wss.prefs.first_day": "First day of week",
  "os.wss.prefs.first_day.monday": "Monday",
  "os.wss.prefs.first_day.sunday": "Sunday",
  "os.wss.lang.fr": "French",
  "os.wss.lang.en": "English",
  "os.wss.placeholder_optional": "Optional",
  "os.wss.none": "—",
  "os.ws.subtitle": "Consolidated view of all your establishments.",
  "os.ws.counts.establishments": "Establishments",
  "os.ws.counts.members": "Members",
  "os.ws.counts.pending_invitations": "Pending invitations",
  "os.ws.cta.add_establishment": "Add an establishment",
  "os.ws.cta.team": "Team",
  "os.ws.kpi.title": "Consolidated metrics",
  "os.ws.kpi.revenue": "Consolidated revenue",
  "os.ws.kpi.orders": "Orders",
  "os.ws.kpi.customers": "Customers",
  "os.ws.kpi.wallet": "Wallet",
  "os.ws.kpi.points": "Points issued",
  "os.ws.kpi.reviews": "Reviews",
  "os.ws.kpi.coming_soon": "Coming soon",
  "os.ws.kpi.reviews_summary": "{count} reviews · {avg}/5",
  "os.ws.kpi.reviews_none": "No reviews",
  "os.ws.stores.title": "Establishments",
  "os.ws.stores.open_cockpit": "Open cockpit",
  "os.ws.stores.today_revenue": "Revenue today",
  "os.ws.stores.today_orders": "Orders",
  "os.ws.stores.wallet": "Wallet",
  "os.ws.stores.status.active": "Open",
  "os.ws.stores.status.inactive": "Closed",
  "os.ws.stores.empty": "No establishment yet.",
  "os.est.title": "Establishments",
  "os.est.subtitle": "Manage all establishments in your workspace.",
  "os.est.search": "Search by name, country or currency…",
  "os.est.count": "{count} establishment(s)",
  "os.est.col.name": "Establishment",
  "os.est.col.country": "Country",
  "os.est.col.currency": "Currency",
  "os.est.col.plan": "Plan",
  "os.est.col.status": "Status",
  "os.est.col.revenue": "Revenue today",
  "os.est.col.orders": "Orders",
  "os.est.col.wallet": "Wallet",
  "os.est.col.actions": "Actions",
  "os.est.empty_search": "No establishment matches your search.",
  "os.ws.activity.title": "Recent activity",
  "os.ws.activity.empty": "No recent activity.",
  "os.ws.activity.invitation_created": "New invitation",
  "os.ws.activity.invitation_accepted": "Invitation accepted",
  "os.ws.activity.store_created": "New establishment",
  "os.ws.quick.title": "Quick actions",
  "os.ws.quick.create_establishment": "Create an establishment",
  "os.ws.quick.invite_member": "Invite a member",
  "os.ws.quick.view_team": "View team",
  "os.ws.quick.view_subscriptions": "View subscriptions",
  "os.ws.quick.soon": "Soon",
  "os.ws.loading": "Loading cockpit…",
  "os.ws.error": "Unable to load the cockpit. Please try again.",
  "os.ws.retry": "Retry",
  "os.owner.establishments.active": "active",
  "os.owner.establishments.open": "Open",
  "os.owner.establishments.add": "Add establishment",
  "os.owner.supervision.allclear_title": "Everything under control",
  "os.owner.supervision.allclear_desc": "No alerts across your {n} establishments",
  "os.owner.supervision.m_establishments": "Active establishments",
  "os.owner.supervision.m_orders": "Orders today",
  "os.owner.supervision.m_loyalty": "Loyalty customers",
  "os.owner.supervision.m_wallets": "Active wallets",
  "os.owner.supervision.no_order_today": "Last order — none today",
  "os.owner.supervision.orders_today": "{n} order(s) today",
  "os.account.role.owner": "Owner",
  "os.account.role.staff": "Staff",
  "os.account.verified": "verified",
  "os.account.logout": "Log out",
  "os.account.subscription": "Subscription",
  "os.account.establishments_singular": "active establishment",
  "os.account.establishments_plural": "active establishments",
  "os.account.manage": "Manage",
  "os.account.help": "Help & Support",
  "os.owner.alerts.title": "Alerts & Insights",
  "os.owner.alerts.empty": "All clear. No alerts.",
  "os.owner.alerts.rewards_unit": "pending validation",
  "os.owner.alerts.wallet_desc": "No top-up in {days} days",
  "os.owner.alerts.loyalty_desc": "No active loyalty customer",
  "os.owner.alerts.stock_out.title": "Out of stock",
  "os.owner.alerts.stock_low.title": "Low stock",
  "os.owner.alerts.ingredient_out.title": "Ingredient out of stock",
  "os.owner.alerts.ingredient_low.title": "Low ingredient stock",
  "os.owner.alerts.rewards_pending.title": "Pending rewards",
  "os.owner.alerts.wallet_inactive.title": "Inactive wallet",
  "os.owner.alerts.loyalty_inactive.title": "Inactive loyalty",
  "os.owner.open_establishment": "Open establishment",
  "os.page.greeting_morning": "Good morning",
  "os.page.greeting_afternoon": "Good afternoon",
  "os.page.greeting_evening": "Good evening",
  "os.page.role_owner_fallback": "boss",
  "os.page.role_manager_fallback": "manager",
  "os.page.your_day": "Here's your day.",
  "os.page.view_client_menu": "View customer menu",
  "os.page.change_shop": "Switch",
  "os.page.kpi_revenue_today": "Revenue today",
  "os.page.kpi_orders": "Orders",
  "os.page.kpi_pending": "Pending",
  "os.page.payments_title": "Today's takings",
  "os.page.pay_wallet": "Wallet",
  "os.page.pay_cash": "Cash",
  "os.page.pay_card": "Card (POS)",
  "os.page.pay_total": "Total",
  "os.page.pay_op_singular": "transaction",
  "os.page.pay_op_plural": "transactions",
  "os.page.badge_card": "Card",
  "os.page.badge_cash": "Cash",
  "os.page.badge_wallet": "Wallet",
  "os.page.alerts_title": "Actions to handle",
  "os.page.alert_rewards_singular": "1 reward to validate",
  "os.page.alert_rewards_plural": "{count} rewards to validate",
  "os.page.alert_paused": "Store paused",
  "os.page.alert_queue": "{count} orders pending",
  "os.page.onboarding_complete": "All set — your establishment is up and running.",
  "os.page.onboarding_hide": "Hide",
  "os.page.onboarding_title": "Your establishment is created",
  "os.page.onboarding_subtitle": "Here are the next steps to make it operational.",
  "os.page.onboarding_done": "Done",
  "os.page.step_add_products_title": "Add your first products",
  "os.page.step_add_products_desc": "Add the first products your customers will be able to buy.",
  "os.page.step_add_products_cta": "Add",
  "os.page.step_menu_title": "Organize your menu",
  "os.page.step_menu_desc_ready": "Organize your products into your menu.",
  "os.page.step_menu_cta": "Set my prices",
  "os.page.step_rewards_title": "Set up your rewards",
  "os.page.step_rewards_desc": "Create your first loyalty perk.",
  "os.page.step_rewards_cta": "Configure",
  "os.page.step_pos_title": "Open the register",
  "os.page.step_pos_desc": "Open your register to start taking payments.",
  "os.page.step_pos_cta": "Open the POS",
  "os.page.step_shop_title": "Your store is ready",
  "os.page.step_shop_desc": "Name, address, country & currency.",
  "os.page.step_shop_cta": "Configure",
  "os.page.step_products_title": "Set your prices",
  "os.page.step_products_desc_draft_one": "{count} draft product — set your prices to start selling.",
  "os.page.step_products_desc_draft_many": "{count} draft products — set your prices to start selling.",
  "os.page.step_products_desc_ready": "Your products now have configured prices.",
  "os.page.step_products_cta": "Set my prices",
  "os.page.step_team_title": "Invite your team",
  "os.page.step_team_desc": "Create a barista access for the POS.",
  "os.page.step_team_cta": "Invite the team",
  "os.page.step_sale_title": "Make your first sale",
  "os.page.step_sale_desc": "Place a test order to verify your setup.",
  "os.page.step_sale_cta": "Open the POS",
  "os.page.step_sale_hint": "Once the register is open, place a test order to complete this step.",
  "os.page.nudge_plan_title": "Discover your recommended plan",
  "os.page.nudge_plan_desc": "START, PRO or FULL depending on your needs.",
  "os.page.nudge_plan_cta": "View plans",
  "os.page.first_sale_title": "Your products are ready to sell.",
  "os.page.first_sale_desc": "Next step: complete your first test sale.",
  "os.page.first_sale_cta": "Open the POS",
  "os.page.quick_access": "Quick access",
  "os.page.quick_pos_title": "Open the POS",
  "os.page.quick_pos_desc": "Process an order",
  "os.page.activity_title": "Recent activity",
  "os.page.activity_see_all": "View all",
  "os.page.activity_empty_title": "No activity yet",
  "os.page.activity_empty_desc": "The day hasn't started yet.",
  "os.page.activity_empty_cta": "Open the POS",
  "os.page.items_singular": "item",
  "os.page.items_plural": "items",
  "os.page.creating_title": "Setting up your store…",
  "os.page.creating_desc": "One moment — we're finalizing your establishment setup.",
  "os.page.empty_create_title": "Create your first establishment",
  "os.page.empty_select_title": "Select your store",
  "os.page.empty_create_subtitle": "It all starts here. In 30 seconds, your store is ready to take payments.",
  "os.page.empty_select_subtitle_one": "You have {count} store configured. Choose which one to manage.",
  "os.page.empty_select_subtitle_many": "You have {count} stores configured. Choose which one to manage.",
  "os.page.empty_create_cta": "Create my first store",
  "os.page.empty_open_shop": "Open {name}",
  "os.page.my_shop_fallback": "my store",
  "os.shell.open_pos": "Open the POS",
  "os.shell.open_nav": "Open navigation",
  "os.shell.close_nav": "Close navigation",
  "os.shell.platform": "Platform",
  "os.shell.language": "Language",
  "os.shell.language_fr": "Français",
  "os.shell.language_en": "English",
  "os.shell.all_establishments": "All establishments",
  "os.sub.eyebrow": "Subscription",
  "os.sub.title": "Choose your SUPERKAWA OS plan",
  "os.sub.intro": "A platform that grows with your establishment. Start simple, add recipes then stock management when you are ready.",
  "os.sub.status.active": "Active subscription",
  "os.sub.status.trial": "Trial in progress",
  "os.sub.status.grace": "Grace period",
  "os.sub.status.expired": "Trial expired",
  "os.sub.status.default": "Subscription status",
  "os.sub.status.your_shop": "Your shop",
  "os.sub.status.day": "day",
  "os.sub.status.days": "days",
  "os.sub.status.before_grace_end": "before grace ends",
  "os.sub.status.remaining_one": "remaining",
  "os.sub.status.remaining_many": "remaining",
  "os.sub.period.monthly": "Monthly",
  "os.sub.period.annual": "Annual",
  "os.sub.period.two_months_free": "2 months free",
  "os.sub.period.suffix_month": "month",
  "os.sub.period.suffix_year": "year",
  "os.sub.recommended": "Recommended",
  "os.sub.current_offer": "Current plan",
  "os.sub.soon_available": "Coming soon",
  "os.sub.redirecting": "Redirecting…",
  "os.sub.subscribe": "Subscribe",
  "os.sub.pay_transfer": "Pay by bank transfer",
  "os.sub.start.tagline": "The essentials to take payments and build loyalty.",
  "os.sub.pro.tagline": "Standardize your Superkawa recipes.",
  "os.sub.full.tagline": "Full operations, ready to scale.",
  "os.sub.feat.client_app": "Customer app",
  "os.sub.feat.pos": "POS checkout",
  "os.sub.feat.wallet_loyalty": "Wallet & loyalty",
  "os.sub.feat.dashboard": "SaaS dashboard",
  "os.sub.feat.recipes": "Superkawa recipes",
  "os.sub.feat.stock_mgmt": "Stock management",
  "os.sub.feat.all_start": "Everything in START",
  "os.sub.feat.all_pro": "Everything in PRO",
  "os.sub.feat.material_cost": "Cost of goods",
  "os.sub.feat.margins": "Margins",
  "os.sub.feat.ingredients_catalog": "Ingredients catalog",
  "os.sub.feat.stock": "Stock",
  "os.sub.feat.inventory": "Inventory",
  "os.sub.feat.stock_alerts": "Stock alerts",
  "os.sub.loading": "Loading pricing…",
  "os.sub.error": "Unable to load pricing right now. Please try again shortly.",
  "os.sub.soon_banner": "💳 Online payment is coming very soon. In the meantime, contact us to activate your plan.",
  "os.sub.pricing_note": "Prices in euros (€), identical for every country. Annual equals 10 months (2 months free).",
  "os.sub.contact_question": "A question? Contact us",
  "os.sub.toast.cancelled": "Payment cancelled. You can try again whenever you like.",
  "os.sub.toast.paid": "Payment received ✓ — your subscription activation will be confirmed very soon.",
  "os.sub.toast.expired": "The payment session expired. Please try again.",
  "os.sub.toast.processing": "Payment is being processed. You will receive a confirmation by email.",
  "os.sub.toast.select_shop": "Select a shop before subscribing.",
  "os.sub.toast.checkout_error": "Unable to start payment. Please try again shortly.",
  "os.saas.days_one": "{n} day remaining",
  "os.saas.days_many": "{n} days remaining",
  "os.saas.badge.trial": "Trial",
  "os.saas.badge.grace": "Grace",
  "os.saas.badge.expired": "Expired",
  "os.saas.badge.active": "Active",
  "os.saas.badge.past_due": "Payment overdue",
  "os.saas.trial.title_ending": "Your trial expires soon — {days}",
  "os.saas.trial.title_active": "Free trial • {days}",
  "os.saas.trial.title_default": "Free trial in progress",
  "os.saas.trial.desc": "Enjoy every feature. Choose your plan to continue without interruption.",
  "os.saas.trial.cta": "See plans",
  "os.saas.grace.title_active": "Grace period active — {days}",
  "os.saas.grace.title_default": "Grace period active",
  "os.saas.grace.desc": "Your trial has ended. Activate a plan now to keep full access.",
  "os.saas.grace.cta": "Activate a plan",
  "os.saas.expired.title": "Your trial has expired",
  "os.saas.expired.desc": "Activate a plan to re-enable all SUPERKAWA OS features.",
  "os.saas.expired.cta": "Activate a plan",
  "os.saas.past_due.title": "Your last payment failed",
  "os.saas.past_due.desc": "Your access stays active for now. Update your payment method to avoid any interruption.",
  "os.saas.past_due.cta": "Update payment",
  "os.saas.suspended.status_paused": "suspended",
  "os.saas.suspended.status_cancelled": "cancelled",
  "os.saas.suspended.title": "Subscription {status} — {name}",
  "os.saas.suspended.desc": "Access will soon switch to read-only. Contact SUPERKAWA to reactivate your subscription.",
  "os.saas.gate.title_paused": "Subscription suspended",
  "os.saas.gate.title_cancelled": "Subscription cancelled",
  "os.saas.gate.title_expired": "Trial expired",
  "os.saas.gate.desc_expired": "Your trial (and grace period) has ended. Activate a plan with SUPERKAWA to re-enable the POS, OS and management.",
  "os.saas.gate.desc_default": "Access to this shop is temporarily blocked. Settle your subscription with SUPERKAWA to re-enable the POS, OS and management.",
  "os.saas.gate.contact": "Contact SUPERKAWA",
  "os.saas.gate.switch_shop": "Switch shop",
  "os.virement.doc_title": "Bank transfer payment — SUPERKAWA OS",
  "os.virement.meta_desc": "Pay for your SUPERKAWA OS subscription by bank transfer. Activation within 24 business hours after the payment is received.",
  "os.virement.hero_eyebrow": "Bank transfer payment",
  "os.virement.hero_title": "Pay for your subscription by bank transfer",
  "os.virement.hero_desc": "Would you rather pay by bank transfer than by card? You can. Your SUPERKAWA OS subscription is activated manually as soon as your payment is received.",
  "os.virement.selected_formule": "Selected plan: {formule}",
  "os.virement.coords_title": "Bank details",
  "os.virement.coords_loading": "Loading bank details…",
  "os.virement.coords_fallback": "Bank details provided on request.",
  "os.virement.label_beneficiary": "Beneficiary",
  "os.virement.label_bank": "Bank",
  "os.virement.label_address": "Address",
  "os.virement.label_iban": "IBAN",
  "os.virement.label_bic": "BIC / SWIFT",
  "os.virement.copy": "Copy",
  "os.virement.copied": "Copied",
  "os.virement.copy_aria": "Copy {label}",
  "os.virement.toast_copied": "{label} copied",
  "os.virement.toast_copy_error": "Copy failed. Please select the text manually.",
  "os.virement.ref_title": "Mandatory reference",
  "os.virement.ref_instruction": "You must include the following reference in your transfer:",
  "os.virement.ref_value_with_formule": "Business name + plan {formule}",
  "os.virement.ref_value_default": "Business name + chosen plan",
  "os.virement.ref_example": "Example: Restaurant Le Palmier - PRO",
  "os.virement.delai_title": "Activation within 24 business hours",
  "os.virement.delai_desc": "As soon as the funds are received, your subscription is activated within 24 business hours. No automatic activation occurs until the transfer is received.",
  "os.virement.steps_title": "Steps",
  "os.virement.step_label": "Step {n}",
  "os.virement.step1_title": "Make your bank transfer",
  "os.virement.step1_desc": "Send the transfer from your bank for the amount of the chosen plan, including the reference below.",
  "os.virement.step2_title": "Send your proof of payment",
  "os.virement.step2_desc": "Send your transfer receipt to {email}.",
  "os.virement.step3_title": "Your subscription is activated",
  "os.virement.step3_desc": "Your subscription is activated within 24 business hours after the funds are received.",
  "os.virement.cta_title": "Transfer completed?",
  "os.virement.cta_desc": "Click below to send us your proof of payment. The message is pre-filled: all you need to do is attach your transfer receipt.",
  "os.virement.cta_done": "I've completed my transfer",
  "os.virement.cta_back_formules": "See plans",
  "os.virement.footer_cgv": "Terms",
  "os.virement.footer_privacy": "Privacy",
  "os.virement.footer_legal": "Legal notice",
  "os.virement.mail_subject": "Bank transfer receipt – SUPERKAWA",
  "os.virement.mail_body": "Hello,\n\nPlease find attached my bank transfer receipt for my SUPERKAWA OS subscription.\n\n- Business name: \n- Plan: {formule}\n- Transfer date: \n\nBest regards,",

  // MB-ACCOUNT-EXIT-1 — "My account" (self-service manager/staff/barista)
  "os.account.title": "My account",
  "os.account.subtitle": "Manage your organization memberships and your SUPERKAWA account.",
  "os.account.loading": "Loading…",
  "os.account.error": "Unable to load your information. Please try again.",
  "os.account.retry": "Retry",
  "os.account.memberships_title": "My organizations",
  "os.account.memberships_desc": "The organizations you belong to as a team member.",
  "os.account.role_manager": "Manager",
  "os.account.role_member": "Team",
  "os.account.role_owner": "Owner",
  "os.account.leave_cta": "Leave this organization",
  "os.account.leave_owner_note": "You are the owner of this organization. Owner exit will be covered by a future professional-account closure flow.",
  "os.account.leave_confirm_title": "Leave this organization?",
  "os.account.leave_confirm_body": "You will lose access to this business and its stores. Your SUPERKAWA account will remain active if you belong to another organization.",
  "os.account.leave_confirm_cta": "Leave",
  "os.account.leave_success": "You have left this organization.",
  "os.account.leave_error": "Unable to leave this organization. Please try again.",
  "os.account.danger_zone": "Deletion zone",
  "os.account.delete_cta": "Delete my SUPERKAWA account",
  "os.account.delete_confirm_title": "Delete my SUPERKAWA account?",
  "os.account.delete_confirm_body": "Your professional access will be removed from every organization you belong to. Some historical records required for security, audit or legal obligations may be retained under an internal, non-directly-identifying reference.",
  "os.account.delete_confirm_cta": "Delete my account",
  "os.account.delete_success": "Your SUPERKAWA account has been deleted. You will be signed out.",
  "os.account.delete_error": "Unable to delete your account. Please try again.",
  "os.account.owner_reserved_title": "Owner actions",
  "os.account.owner_reserved_desc": "As an owner, the manager/staff/barista self-service leave/delete actions do not apply to your account. The following actions will be available in a future lot:",
  "os.account.owner_cancel_subscription": "Cancel my subscription",
  "os.account.owner_close_store": "Close this store",
  "os.account.owner_close_company": "Close my SUPERKAWA professional account",
  "os.account.owner_reserved_note": "Not available yet.",
  "os.pay.return.title": "Back from Stripe",
  "os.pay.return.notice": "We received your return from Stripe. Returning is not enough to enable card payments: we are checking your account status with Stripe.",
  "os.pay.return.checking": "Checking your account status…",
  "os.pay.return.retry": "Check again",
  "os.pay.refresh.title": "The activation link is no longer valid",
  "os.pay.refresh.notice": "The Stripe link expired, was already used or did not complete. No payment is enabled at this stage. Request a new link to resume activation.",
  "os.pay.refresh.cta": "Get a new link",
  "os.pay.back": "Back to management",
  "os.pay.status.active": "Card payments are active on your Stripe account.",
  "os.pay.status.pending": "Your account is being verified by Stripe. Card payments are not active yet.",
  "os.pay.status.onboarding_required": "Some information is still needed by Stripe. Card payments are not active yet.",
  "os.pay.status.restricted": "Your Stripe account is restricted. Card payments are not active.",
  "os.pay.err.owner_only": "Only the owner can check or restart payment activation.",
  "os.pay.err.not_found": "Payment account not found.",
  "os.pay.err.unavailable": "Card payments are not available at the moment.",
  "os.pay.err.session": "Your session expired. Sign in again and retry.",
  "os.pay.err.invalid_link": "Invalid return link.",
  "os.pay.err.generic": "Unable to reach the payment service. Please try again shortly.",
  "os.pay.page.title": "Customer payments",
  "os.pay.page.subtitle": "Take card payments from your customers at your establishment.",
  "os.pay.page.loading": "Loading payments…",
  "os.pay.page.country": "Country",
  "os.pay.page.currency": "Currency",
  "os.pay.page.customers.title": "Customer payments",
  "os.pay.page.customers.note": "Your customers' payments go directly to your account: Superkawa neither receives nor holds them.",
  "os.pay.page.readonly": "Only the owner can configure payments.",
  "os.pay.page.action.configure": "Enable card payments",
  "os.pay.page.action.continue": "Continue activation",
  "os.pay.page.action.refresh": "Refresh status",
  "os.pay.page.no_shop.title": "No establishment selected",
  "os.pay.page.no_shop.desc": "Choose an establishment to manage its payments.",
  "os.pay.page.err.forbidden": "You don't have access to this establishment's payments.",
  "os.pay.page.err.conflict": "The payments status has changed. Refresh the page and try again.",
  "os.pay.page.status.unavailable.badge": "Unavailable",
  "os.pay.page.status.unavailable.desc": "Card payments can't be enabled for this establishment.",
  "os.pay.page.status.not_configured.badge": "Not set up",
  "os.pay.page.status.not_configured.desc": "Card payments aren't enabled for this establishment yet.",
  "os.pay.page.status.creating.badge": "Being created",
  "os.pay.page.status.creating.desc": "Your payment account is being created.",
  "os.pay.page.status.onboarding_required.badge": "Information required",
  "os.pay.page.status.onboarding_required.desc": "Some information must be provided to our payment partner to enable card payments.",
  "os.pay.page.status.pending_verification.badge": "Verification in progress",
  "os.pay.page.status.pending_verification.desc": "Your information is being verified. Card payments are not active yet.",
  "os.pay.page.status.active.badge": "Active",
  "os.pay.page.status.active.desc": "Card payments are active for this establishment.",
  "os.pay.page.status.restricted.badge": "Restricted",
  "os.pay.page.status.restricted.desc": "Card payments aren't active yet. Complete the information requested by our payment partner, or refresh the status.",
  "os.pay.page.status.error.badge": "To check",
  "os.pay.page.status.error.desc": "The payments status couldn't be determined. Contact support if the problem persists.",
  "os.pay.page.reason.market_unsupported": "This establishment's country isn't supported yet.",
  "os.pay.page.reason.currency_mismatch": "The establishment's currency doesn't match its country's.",
  "os.pay.page.reason.country_not_available": "Card payments aren't open in this country yet.",
  "os.pay.page.reason.provider_unavailable": "The payment service is temporarily unavailable.",
  "os.pay.page.reason.generic": "Card payments aren't available for this establishment.",
  "os.pay.page.sub.title": "Professional subscription",
  "os.pay.page.sub.note": "Your Superkawa subscription is separate from your customers' payments.",
  "os.pay.page.sub.manage": "Manage subscription",
};
